export default __webpack_public_path__ + "static/media/children.8100097c.webp";